import { createAsyncThunk } from '@reduxjs/toolkit';
import formStepsAPI from '@infrastructure/form-steps-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const createFormStepAsync = createAsyncThunk('formSteps/create', async (formStep, { rejectWithValue }) => {
    try {
        const response = await formStepsAPI.createFormStep(formStep);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFormStepAsync = createAsyncThunk('formSteps/update', async (formStep, { rejectWithValue }) => {
    try {
        const response = await formStepsAPI.updateFormStep(formStep);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteFormStepAsync = createAsyncThunk('formSteps/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await formStepsAPI.deleteFormStep(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFormStepByIdAsync = createAsyncThunk('formSteps/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await formStepsAPI.getFormStepById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFormStepsByEventIdAsync = createAsyncThunk('formSteps/getByEventId', async (eventId, { rejectWithValue }) => {
    try {
        const response = await formStepsAPI.getFormStepsByEventId(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
